import React, { useEffect, useState } from 'react'
import AdministrationForm from '../UI/AdministrationForm/AdministrationForm'
import helper from '../../Services/helper'

const Branch = (props) => {
    const [modal, setModal] = useState()
    const t = (key) => {
        return helper().translate(key);
    }

    const headers = [
        { key: 'name', columnName: t('NAME'), type: 'input', required: true },
        { key: 'unitNo', columnName: t('UNIT_NUMBER'), type: 'input', required: false },
        { key: 'address', columnName: t('ADDRESS'), type: 'input', required: false },
        { key: 'contactPerson', columnName: t('CONTACT_PERSON'), type: 'input', required: false },
        { key: 'email', columnName: t('EMAIL'), type: 'input', required: false },
        { key: 'phone', columnName: t('PHONE'), type: 'input', required: false },
    ]

    const model = {
        id: 0,
        name: "",
        unitNo: "", 
        address: "",
        contactPerson: "",
        email: "",
        phone: "",
        status: 0
    }

    useEffect(() => {
        setModal(props.modal)
    }, [props.modal]);

    return (
        <div>
            <AdministrationForm new={modal} headers={headers} table="Branches" name="braches" model={model} formType="modal" />
        </div>
    )
}

export default Branch
